import React, { memo } from 'react';

import './Tabs.scss';

interface TabsProps {
  children: React.ReactNode;
  onChange: void;
}

const Tabs = ({ children, onChange }) => {
  return <nav styleName="tabs">
    {React.Children.map(children, child => {
      return React.cloneElement(child, { onChange });
    })}
  </nav>;
};

export default memo(Tabs);
